import { c as _c } from "react/compiler-runtime";
/** biome-ignore-all lint/suspicious/noArrayIndexKey: copied from cc-shopping-client */
import type { StructuredContent } from '@repo/contracts/cross-site/structured-content/types';
import { css } from '@repo/pandacss/css';
import { MaskIcon } from '@repo/ui/primitives/MaskIcon';
import { Typography } from '@repo/ui/Typography';
import { StructuredContentRenderer } from '@/shared/ui/structured-content/StructuredContentRenderer';
import { conBulletBefore, conBulletClass, hasSCListType, proBulletBefore, proBulletClass, proConsListItemBase } from './utils';
const styles = {
  proConsListWrapper: css({
    flex: '[1]'
  }),
  proConsPlainList: css({
    pt: '0',
    pb: '3',
    pl: '0'
  }),
  proConsPlainListItem: css(proConsListItemBase),
  proConsScListWrapperPros: css({
    '& ul': {
      my: '0',
      pl: '0',
      pb: '3',
      listStyleType: 'none'
    },
    '& li': {
      ...proConsListItemBase,
      mt: '0',
      _before: proBulletBefore
    }
  }),
  proConsScListWrapperCons: css({
    '& ul': {
      my: '0',
      pl: '0',
      pb: '3',
      listStyleType: 'none'
    },
    '& li': {
      ...proConsListItemBase,
      mt: '0',
      _before: conBulletBefore
    }
  }),
  proConsListItemText: css({
    lineHeight: '[1.5rem]',
    '& span': {
      fontSize: {
        base: '[15px]',
        md: '1rem'
      }
    }
  })
} as const;
type ProsOrCons = 'pros' | 'cons';
type ProConsListProps = {
  items: StructuredContent[] | string[];
  type: ProsOrCons;
};
function ProConsBullet(t0) {
  const $ = _c(6);
  const {
    type
  } = t0;
  const bulletClass = type === "pros" ? proBulletClass : conBulletClass;
  const glyph = type === "pros" ? "bullet-plus" : "bullet-minus";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      boxSize: "[10px]"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== glyph) {
    t2 = <MaskIcon glyph={glyph} css={t1} />;
    $[1] = glyph;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== bulletClass || $[4] !== t2) {
    t3 = <span className={bulletClass}>{t2}</span>;
    $[3] = bulletClass;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export const ProConsList = t0 => {
  const $ = _c(12);
  const {
    items,
    type
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = hasSCListType(items);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shouldRenderSCListItems = t1;
  const isProsList = type === "pros";
  const scListWrapperClass = isProsList ? styles.proConsScListWrapperPros : styles.proConsScListWrapperCons;
  const t2 = isProsList ? "Pros" : "Cons";
  let t3;
  if ($[2] !== t2) {
    t3 = <Typography variant="text.bold">{t2}</Typography>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== items || $[5] !== scListWrapperClass || $[6] !== shouldRenderSCListItems || $[7] !== type) {
    t4 = shouldRenderSCListItems ? items.map((item, index) => <div key={`${type.slice(0, 2)}-${index}`} className={scListWrapperClass}><StructuredContentRenderer doc={item} /></div>) : <ul className={styles.proConsPlainList}>{items.map((item_0, index_0) => <li key={`${type.slice(0, 2)}-${index_0}`} className={styles.proConsPlainListItem}><ProConsBullet type={type} /><Typography variant="text" className={styles.proConsListItemText}><StructuredContentRenderer doc={item_0} /></Typography></li>)}</ul>;
    $[4] = items;
    $[5] = scListWrapperClass;
    $[6] = shouldRenderSCListItems;
    $[7] = type;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className={styles.proConsListWrapper}>{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};